export default __webpack_public_path__ + "static/media/svg-1.c9c88a21.svg";